export const navLinks = [
  {
    id: 1,
    linkText: "Home",
    url: "/",
  },
  {
    id: 2,
    linkText: "Swimming Pools",
    url: "/swimming-pool",
    // subLinks: [
    //   {
    //     id: 1,
    //     linkText: "Competition Pool",
    //     // url: "/swimming-pool/competition-pool",
    //   },
    //   {
    //     id: 2,
    //     linkText: "Clubs & Resorts",
    //     // url: "/swimming-pool/clubs-resorts",
    //   },
    //   {
    //     id: 3,
    //     linkText: "Residential Pools",
    //     // url: "/swimming-pool/residential-pools",
    //   },
    //   {
    //     id: 4,
    //     linkText: "Water Parks",
    //     // url: "/swimming-pool/water-parks",
    //   },
    // ],
  },
  {
    id: 3,
    linkText: "Services",
    url: "/services",
    // subLinks: [
    //   {
    //     id: 1,
    //     linkText: "Turnkey Jobs",
    //     // url: "/services/turnkey-jobs",
    //   },
    //   {
    //     id: 2,
    //     linkText: "Consultancy",
    //     // url: "/services/consultancy",
    //   },
    //   {
    //     id: 3,
    //     linkText: "Renovation",
    //     // url: "/services/renovation",
    //   },
    //   {
    //     id: 4,
    //     linkText: "Chemical & Spares",
    //     // url: "/services/chemical-spares",
    //   },
    //   {
    //     id: 5,
    //     linkText: "Maintenance Services",
    //     // url: "/services/maintenance",
    //   },
    //   {
    //     id: 6,
    //     linkText: "Pool Care",
    //     // url: "/services/pool-care",
    //   },
    // ],
  },
  {
    id: 4,
    linkText: "Premium Works",
    url: "/premium-works",
    // subLinks: [
    //   {
    //     id: 1,
    //     linkText: "Steam",
    //     // url: "/premium-works/steam",
    //   },
    //   {
    //     id: 2,
    //     linkText: "Sauna",
    //     // url: "/premium-works/sauna",
    //   },
    //   {
    //     id: 3,
    //     linkText: "Jacuzzi",
    //     // url: "/premium-works/jacuzzi",
    //   },
    //   {
    //     id: 4,
    //     linkText: "Fountain",
    //     // url: "/premium-works/fountain",
    //   },
    //   {
    //     id: 5,
    //     linkText: "Playground Equipment",
    //     // url: "/premium-works/playground-equipment",
    //   },
    // ],
  },
  {
    id: 5,
    linkText: "Gallery",
    url: "/gallery",
  },
  {
    id: 6,
    linkText: "Products",
    url: "/products",
    // subLinks: [
    //   // {
    //   //   id: 1,
    //   //   linkText: "Other Products",
    //   //   url: "/products/other-products",
    //   // },
    // ],
  },
  {
    id: 7,
    linkText: "Contact",
    url: "/contact",
    
  },
];
